import { ConnectionNames } from "../../../Contracts";
import { AsyncSocket, connectionStore, ConfigStore } from "../../../Common";
import { openBetsSocketConnectionHandlers } from "../OpenBetsSocketConnectionHandlers";
import { OBQRequestFormatter } from "../OBQRequestFormatter";
import { OBQResponseFormatter } from "../OBQResponseFormatter";
export function createOpenBetsConnection(connConfig) {
    const conn = new AsyncSocket({
        url: {
            baseUrl: connConfig.baseUrl,
            queryParams: {
                jwt: ConfigStore.config.connections.jwt
            }
        },
        handlers: openBetsSocketConnectionHandlers(OBQRequestFormatter, OBQResponseFormatter)
    });
    connectionStore.set(ConnectionNames.openBets, conn);
    return conn;
}
//# sourceMappingURL=CreateOpenBetConnection.js.map